import React from 'react';
import classNames from 'classnames';
import dayjs, { Dayjs } from 'dayjs';
import { Event } from './types';
import GenerateDay from './GenerateDay';

interface Props {
  displayDate: Dayjs;
  selected: (data: Dayjs) => void;
  disabled: (data: Dayjs) => void;
  activeId: string | number;
  setActiveId: (id: string | number) => void;
  events: Event[];
  eventCard?: (data: Event) => React.JSX.Element;
  loading?: boolean;
}

const PopulateWeeks = ({
  displayDate,
  selected,
  disabled,
  activeId,
  setActiveId,
  events,
  eventCard,
  loading,
}: Props) => {
  const weeks = [];
  let week = [];
  const daysInMonth = displayDate?.daysInMonth();
  const startOfMonth = dayjs(displayDate).set('date', 1);
  const offset = startOfMonth.day();

  week = week.concat(
    Array.from({ length: offset }, (x, i) => (
      <div
        key={`empty-${i}`}
        className={classNames('d-grid grid-cols-7', {
          skeleton: loading,
        })}
      />
    )),
  );

  for (let i = 1; i <= daysInMonth; ++i) {
    const date = dayjs(displayDate).set('date', i);
    const isSelected = Boolean(selected(date));
    const disable = Boolean(disabled(date));
    const isToday = date.isSame(dayjs(), 'day');
    const day = (
      <GenerateDay
        key={i}
        i={i}
        isSelected={isSelected}
        disabled={disable}
        isToday={isToday}
        displayDate={displayDate}
        activeId={activeId}
        setActiveId={setActiveId}
        events={events}
        eventCard={eventCard}
        loading={loading}
      />
    );

    week.push(day);
    if ((i + offset) % 7 === 0 || i === daysInMonth) {
      if (week.length < 7) {
        week = week.concat(
          Array.from({ length: 7 - week.length }, (x, i) => (
            <div
              key={`empty-${i}`}
              className={classNames('d-grid grid-cols-7', {
                skeleton: loading,
              })}
            />
          )),
        );
      }
      weeks.push(
        <div className="d-grid grid-cols-7" key={`weeks-${i}`}>
          {week}
        </div>,
      );
      week = [];
    }
  }
  return weeks;
};

export default PopulateWeeks;
